import React, { useCallback } from "react";

import { MenuItem } from "@fluentui/react-components";
import { UserDropdownModel } from "./useUserDropDownItems";
import { observer } from "mobx-react";
import { useStyles } from "./UserDropDown.styles";

interface IUserDropDownItemProps {
    item: UserDropdownModel;
}

const UserDropDownItemBase = ({ item }: IUserDropDownItemProps) => {
    const classNames = useStyles();

    const openLink = useCallback(() => {
        window.open(item.href, "_blank");
    }, [item.href]);

    return !item.href ? (
        <MenuItem key={item.key} onClick={item.onClick} className={classNames.userMenu} aria-label={item.text}>
            {item.text}
        </MenuItem>
    ) : (
        <MenuItem key={item.key} onClick={openLink} className={classNames.userMenu} aria-label={item.text}>
            {item.text}
        </MenuItem>
    );
};

export const UserDropDownItem = observer(UserDropDownItemBase);
